// extracted by mini-css-extract-plugin
module.exports = {"confirmBtn":"StripeCard_confirmBtn__Pdswz","confirmBtnDiv":"StripeCard_confirmBtnDiv__3lKF5","AddCardDiv":"StripeCard_AddCardDiv__2st_q"};